import { cva, type VariantProps } from 'class-variance-authority';

export const sliderVariants = cva(
  'flex w-full items-center [--slider-thumb-border-width:1px]',
  {
    variants: {
      variant: {
        primary:
          '[--slider-track:var(--color-ui-slider-track)] [--slider-fill:var(--color-ui-slider-fill)] [--slider-thumb:var(--color-ui-slider-thumb)] [--slider-thumb-border:var(--color-ui-slider-thumb-border)]',
        muted:
          '[--slider-track:rgb(75_85_99_/_0.35)] [--slider-fill:var(--color-ui-muted)] [--slider-thumb:var(--color-ui-muted)] [--slider-thumb-border:var(--color-ui-primary-foreground)]',
      },
      size: {
        sm: '[--slider-thumb-size:14px] [--slider-track-height:3px]',
        md: '[--slider-thumb-size:16px] [--slider-track-height:4px]',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
);

export type SliderVariantProps = VariantProps<typeof sliderVariants>;
